import { render, staticRenderFns } from "./DeliveryOnMap.vue?vue&type=template&id=366ad924&lang=pug&"
import script from "./DeliveryOnMap.vue?vue&type=script&lang=ts&"
export * from "./DeliveryOnMap.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryOnMap.vue?vue&type=style&index=0&id=366ad924&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports